import { Component } from '@angular/core';

@Component({
  selector: 'app-error',
  standalone: true,
  template: `
    <div class="main-content">
      <section class="access">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-xs-12">
              <h2 class="title">現在ご利用いただけません</h2>
              <br /><br />
              <p>ご利用いただき、誠にありがとうございます。</p>
              <p>現在こちらのページはご利用いただけません。</p>
              <p>しばらく時間を置いてから、再度ご利用をお願いいたします。</p>
              <p>ご不便をお掛け致しますが、ご理解いただきますようお願い申し上げます。</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,
})
export class ErrorComponent {}
